import { get, post, put, deleteUrl, postUrl } from './index'

import base from './base'

const api = base + 'official/website/'
const utility = base + 'system/online/'
const solr = base + 'solr/'

export default {
    getZdType: (type) => { // 用type获取字典
        return get(api + 'dict/queryListByType/' + type)
    },
    getZdCode: (code) => { // 用code获取字典
        return get(api + 'dict/queryListByType/' + code)
    },
    getJson: (code, fn) => { // 获取JSON串
        return get(api + 'setting/getContentByCode/' + code).then(res => {
            fn(res && res.data ? JSON.parse(res.data) : '')
        })
    },
    queryDistanceTimeNum: () => { // 查询大会距离时间
        return get(api + 'queryDistanceTimeNum')
    },
    queryOfficialBannerList: (params) => {  //查询banner列表
        params.pageSize = 9999
        return post(api + 'officialBanner/queryOfficialBannerList', params)
    },
    queryJournalismList: (params) => {  //查询新闻中心
        return post(api + 'journalism/queryJournalismList', params)
    },
    queryPartnersList: (params) => {  //查询合作伙伴
        return post(api + 'partners/queryPartnersList', params)
    },
    queryPartnersDeatil: (uuid) => {  //查询合作伙伴详情
        return get(api + 'partners/queryPartners/' + uuid)
    },
    queryForumList: (params) => {  //查询大会日程
        return post(api + 'officialFront/queryOfficialFrontForumList', params)
    },
    queryOfficialGuestList:(params) => {  //查询嘉宾
        return post(api + 'officialGuest/queryOfficialGuestList', params)
    },
    queryCharacteristicActivityList:() => {  //查询赛事评奖
        return post(api + 'characteristicActivity/queryCharacteristicActivityList')
    },
    queryOfficialSettingList: () => {  //查询配置信息列表
        return post(api + 'officialSetting/queryOfficialSettingList')
    },
    queryOfficialFileList: (params) => {  //查询文件信息列表
        return post(api + 'officialFile/queryOfficialFileList',params)
    },
    queryExhibitionAreaList: () => {  //查询展区
        return post(api + 'exhibitionArea/queryExhibitionAreaList')
    },
    exhibitionDirectory: (params) => {  //查询展商名录
        return post(api + 'ExhibitionMerchantDirectories/queryExhibitionMerchantDirectoriesList', params)
    },
    queryJournalismList: (params) => { //查询新闻中心
        return post(api + 'journalism/queryJournalismList', params)
    },
    queryJournalism: (uuid) => { //查询新闻详情
        return get(api + 'journalism/queryJournalism/' + uuid)
    },
    queryCharacteristicActivityList: (params) => { //查询赛事评奖信息列表
        return post(api + 'characteristicActivity/queryCharacteristicActivityList', params)
    },
    queryCharacteristicActivity: (uuid) => { //查询赛事评奖信息
        return get(api + 'characteristicActivity/queryCharacteristicActivity/' + uuid)
    },
    queryCommonProblemList:(params)=>{  //查询常见问题
        return post(api + 'commonProblem/queryCommonProblemList',params)
    },
    apply:(params)=>{  //查询常见问题
        return post(api + 'attendance/apply',params)
    },
    queryForumInfo:(uuid)=>{  //论坛详情
        return get(api + 'officialFront/queryOfficialFrontForum/' + uuid)
    },
    queryPreviousReviewsList:(data)=>{  // 查询往届亮点信息
        return post(api + 'previousReviews/queryPreviousReviewsList', data)
    },
    queryPreviousIntroductionList:(data)=>{  // 查询往届介绍信息
        return post(api + 'previousIntroduction/queryPreviousIntroductionList', data)
    },
    queryOfficialForumConfigList:(data)=>{  // 查询论坛配置信息
        return post(api + 'officialForumConfig/queryOfficialForumConfigList', data)
    },
    queryOfficialForumList:(data)=>{  // 查询论坛配置信息
        return post(api + 'officialForum/queryOfficialForumList', data)
    },
    queryOfficialForumByUuid:(uuid)=>{  //根据uuid查询往届论坛配置信息
        return get(api + 'officialForum/queryOfficialForumByUuid/' + uuid)
    },
    queryOfficialSpeechGuestList:(data)=>{  // 查询官网大会嘉宾信息列表
        return post(api + 'officialFront/queryOfficialFrontGuestList', data)
    },
    queryOfficialFrontGuest:(uuid)=>{  //根据uuid查询嘉宾信息
        return get(api + 'officialFront/queryOfficialFrontGuest/' + uuid)
    },
    queryOfficialCreativeList:(data)=>{  // 查询官网系列活动、公益、应用体验
        return post(api + 'officialFront/queryOfficialCreativeList', data)
    },
    getFrontCreativeDetail:(uuid)=>{  // 查询官网系列活动、公益、应用体验详情
        return get(api + 'officialFront/getFrontCreativeDetail/' + uuid)
    },
    queryOfficialFrontPerimeterList:(data)=>{  // 查询官网周边
        return post(api + 'officialFront/queryOfficialFrontPerimeterList', data)
    },
    getOfficialFrontPerimeter:(uuid)=>{  // 查询官网周边详情
        return get(api + 'officialFront/getOfficialFrontPerimeter/' + uuid)
    },
    getOfficialFrontBanner:()=>{  // 查询官网banner
        return get(api + 'officialFront/getOfficialFrontBanner')
    },
    queryOfficialFrontJournalismList:(data)=>{  // 官网查询置顶新闻、大会发布列表
        return post(api + 'officialFront/queryOfficialFrontJournalismList', data)
    },
    queryOfficialPreviousForumType:(data)=>{  // 查询官网论坛搜索类型信息待年份id查询往届，否则为高端论坛查询
        return get(api + 'officialFront/queryOfficialPreviousForumType', data)
    },
    queryOfficialExhibitionType:()=>{  // 查询展商名录搜索类型
        return get(api + 'officialFront/queryOfficialExhibitionType')
    },
    hitRecord:(data)=>{  // 检索结果点击痕迹记录2023
        return post(solr + 'search/hitRecord', data)
    },
    gethitRecord:(maxSize)=>{  // 检索结果点击痕迹记录2023
        return get(solr + `search/index/${maxSize}`)
    },
    searchQuery:(data)=>{  // ES记录检索
        return post(solr + 'search/query', data)
    },
    searchQuery:(data)=>{  // ES记录检索
        return post(solr + 'search/query', data)
    },
    queryAdvertByCode:(code)=>{  // 字典
        return get(api + `frontAdvert/queryAdvertByCode/${code}`)
    },
    queryTreasureZhenGuanList:(data)=>{  // 查询镇馆之宝信息列表
        return post(api + 'queryTreasureZhenGuanList', data)
    },
    queryTreasureZhenGuan:(uuid)=>{  // 查询镇馆之宝信息详情
        return get(api + `treasureZhenGuan/queryTreasureZhenGuan/${uuid}`)
    },
    getH5CompanyDetail:(companyUuid)=>{  // 展商目录企业详情接口
        return get(api + `onLineCompany/getH5CompanyDetail/${companyUuid}`)
    },
    getH5MerchantList:(data)=>{  // 查询展商名录信息列表2023
        return post(api + 'getH5MerchantList', data)
    },
    getH5MerchantDetail:(merchantUuid)=>{  // 查询H5企业详情2023
        return get(api + `onLineCompany/getH5MerchantDetail/${merchantUuid}`)
    },
    getConfigByCode:(code)=>{  // 根据code查询自定义配置信息  // code编码-> 官网-配置:official_website 官网-首页弹出公告-引导页配置:official_website_guide 官网-大会简介:official_introduction REG企业配置：reg_enterprise_config
        return get(api + `officialFront/getConfigByCode/${code}`)
    },
    queryOfficialCircleColumn:(type)=>{  // 查询官网Circle 栏目
        return post(api + `officialFront/queryOfficialCircleColumn/${type}`)
    },
}



// WEBPACK FOOTER //
// ./src/api/protal.js